import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './gradient-icon.scss';

export function GradientIcon({ icon, iconClassName = null }) {
  return <i className={classnames('gradient-icon', icon, iconClassName)} aria-hidden />;
}

GradientIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  iconClassName: PropTypes.string,
};
